'use client';

import { useNav } from '@/components/NavProvider';
import HeaderClient from '@/components/HeaderClient';

export default function Header({ transparent = true }: { transparent?: boolean }) {
  const { headerItems, ctaButtons } = useNav();
  return <HeaderClient headerItems={headerItems} ctaButtons={ctaButtons} transparent={transparent} />;
}
